var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgXrp = function SvgXrp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 44 44"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#xrp_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#23292F",
    d: "M22 44c12.15 0 22-9.85 22-22S34.15 0 22 0 0 9.85 0 22s9.85 22 22 22"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M31.721 11h3.974l-8.27 8.19a7.73 7.73 0 0 1-10.85 0L8.299 11h3.98l6.284 6.22a4.89 4.89 0 0 0 6.87 0l6.29-6.22Zm-19.49 22.774H8.25l8.326-8.24a7.73 7.73 0 0 1 10.848 0l8.326 8.239h-3.98L25.437 27.5a4.89 4.89 0 0 0-6.87 0l-6.339 6.274z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "xrp_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h44v44H0z"
  })))));
};
export default SvgXrp;